"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetadata = getMetadata;
exports.getParserOpts = getParserOpts;
exports.locatePluginOpts = locatePluginOpts;
exports.parseConfigurationDirectives = parseConfigurationDirectives;

var _babylonLightscript = require("@oigroup/babylon-lightscript");

var parser = _interopRequireWildcard(_babylonLightscript);

var _package = require("../package.json");

var _package2 = _interopRequireDefault(_package);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function getMetadata() {
  return {
    parser,
    getParserOpts,
    parseConfigurationDirectives,
    name: _package2.default.name,
    version: _package2.default.version,
    options: {
      stdlib: {
        description: "Configure the LightScript standard library"
      },
      patternMatching: {
        description: "Test and branch using `match` keyword",
        valueType: "option",
        options: ["default", "enhanced"],
        defaultValue: "default",
        stage: "1"
      },
      bangCall: {
        description: "Call functions with paren-free syntax using `!`",
        valueType: "boolean",
        stage: "0"
      },
      safeCall: {
        description: "Call a function using `?` to check callability first",
        valueType: "boolean"
      },
      existential: {
        description: "Postfix `?` checks that an expression is not loose-equal to `null`",
        valueType: "boolean"
      },
      enhancedComprehension: {
        description: "Positional comprehensions and `case` syntax for comprehensions",
        valueType: "boolean",
        stage: "0"
      },
      noEnforcedSubscriptIndentation: {
        description: "Do not enforce indentation for subscripts on subsequent lines.",
        valueType: "boolean"
      },
      useRequire: {
        description: "Generate `require` rather than `import` when the compiler introduces a module.",
        valueType: "boolean"
      },
      flippedImports: {
        description: "Allow imports via `import 'path': [specifier]` syntax.",
        valueType: "boolean"
      },
      disableJsx: {
        description: "Don't parse JSX expressions.",
        valueType: "boolean"
      },
      disableFlow: {
        description: "Don't parse Flow type annotations.",
        valueType: "boolean"
      },
      preferObjectLiteral: {
        description: "Resolve object-block ambiguity by parsing object literals whenever possible.",
        valueType: "boolean"
      },
      placeholderArgs: {
        description: "Specify arguments for a function using placeholders in the body.",
        valueType: "boolean"
      },
      placeholder: {
        description: "Specify an identifier to be transformed into PlaceholderExpression.",
        valueType: "string"
      },
      pipeCall: {
        description: "a |> b infix binary operator invokes b(a)",
        valueType: "boolean"
      }
    }
  };
}function getParserOpts(pluginOpts, initialParserOpts) {
  var parserOpts = initialParserOpts || {};
  parserOpts.parser = parser.parse;

  parserOpts.plugins = parserOpts.plugins || [];
  var plugins = parserOpts.plugins;

  plugins.unshift("lightscript");
  plugins.push("objectRestSpread", "asyncFunctions", "asyncGenerators", "classProperties", "classConstructorCall", "decorators", "dynamicImport", "doExpressions");

  if (!(pluginOpts == null ? null : pluginOpts.disableJsx)) plugins.push("jsx");
  if (!(pluginOpts == null ? null : pluginOpts.disableFlow)) plugins.push("flow");
  if (pluginOpts == null ? null : pluginOpts.safeCall) plugins.push("safeCallExpression");
  if (pluginOpts == null ? null : pluginOpts.existential) plugins.push("existentialExpression");
  if (pluginOpts == null ? null : pluginOpts.bangCall) plugins.push("bangCall");
  if (!(pluginOpts == null ? null : pluginOpts.noEnforcedSubscriptIndentation)) plugins.push("enforceSubscriptIndentation");
  if (pluginOpts == null ? null : pluginOpts.flippedImports) plugins.push("flippedImports");
  if (pluginOpts == null ? null : pluginOpts.enhancedComprehension) plugins.push("enhancedComprehension");
  if (pluginOpts == null ? null : pluginOpts.preferObjectLiteral) plugins.push("objectBlockAmbiguity_preferObject");
  if (pluginOpts == null ? null : pluginOpts.placeholderArgs) plugins.push("syntacticPlaceholder");
  if (pluginOpts == null ? null : pluginOpts.placeholder) {
    parserOpts.placeholder = pluginOpts.placeholder;
  }if (pluginOpts == null ? null : pluginOpts.pipeCall) plugins.push("pipeCall");

  // TODO: watch upstream on pattern matching; default to their syntax when complete
  // patternMatchingVersion = pluginOpts?.patternMatching or "v4"
  // if patternMatchingVersion != "disabled":
  //   plugins.push(`match_${patternMatchingVersion}`)
  plugins.push("match");

  return parserOpts;
} // Attempt to determine whether a post-processed Babel plugin is this
// plugin. This is necessary because Babel doesn't specify the individual
// plugin configuration during manipulateOptions, only the global configuration.
// But we need the local plugin config there to enable parser flags.
// EXTREMELY hackish.
function isMe(entry, thisPlugin) {
  return entry.manipulateOptions === thisPlugin.manipulateOptions;
}function locatePluginOpts(opts, thisPlugin) {
  var plugins = opts == null ? null : opts.plugins;
  if (!plugins) return {};

  for (var _i4 = 0, _len4 = plugins.length; _i4 < _len4; _i4++) {
    var _plugin = plugins[_i4];
    if (Array.isArray(_plugin)) {
      if (isMe(_plugin[0], thisPlugin)) return _plugin[1];
    } else {
      if (isMe(_plugin, thisPlugin)) return {};
    }
  }return {};
}function eatFluff(code) {
  code = code.trim();
  var matches = code.match(/^(?:\/\/[^\r\n]*\r?\n?\s*)+([^]*)$/);
  if (matches) return matches[1];else {
    var lcMatches = code.match(/^(?:\/\*[^]*?\*\/\s*)+([^]*)$/);
    if (lcMatches) return lcMatches[1];else return code;
  }
}function eatDirective(code, directives) {
  code = code.trim();
  var matches = code.match(/^'((?:[^'\\]|\\.)*)'\s*;?\s*([^]*)$/);
  if (matches) {
    directives.push(matches[1]);
    return matches[2];
  } else {
    var dqMatches = code.match(/^"((?:[^"\\]|\\.)*)"\s*;?\s*([^]*)$/);
    if (dqMatches) {
      directives.push(dqMatches[1]);
      return dqMatches[2];
    } else {
      return code;
    }
  }
} // XXX: This is somewhat hackish. We can probably get Babylon to just parse the
// directives off the Program block as a plugin or something.
function getDirectives(code) {
  var directives = [];
  var before = code,
      after = void 0;
  // eslint-disable-next-line no-constant-condition
  while (true) {
    after = eatDirective(eatFluff(before), directives);
    if (after === before) break;
    before = after;
  }return directives;
}function getClauseOptions(opts, clause) {
  clause = clause.split(':');
  if (clause.length === 2) {
    var opt = clause[0].trim();
    var val = clause[1].trim();
    if (opt.length && val.length) {
      try {
        return opts[opt] = JSON.parse(val);
      } catch (err) {
        return;
      }
    }
  } else if (clause.length === 1) {
    var _opt = clause[0].trim();
    if (_opt.length) return opts[_opt] = true;
  }
}function getWithOptions(opts, wc) {
  var clauses = wc.split(',');
  for (var _i5 = 0, _len5 = clauses.length; _i5 < _len5; _i5++) {
    var _clause = clauses[_i5];
    getClauseOptions(opts, _clause);
  }
}function parseConfigurationDirectives(code) {
  var result = {};
  var directives = getDirectives(code);
  for (var _i6 = 0, _len6 = directives.length; _i6 < _len6; _i6++) {
    var _directive = directives[_i6];
    var matches = _directive.match(/^use \@oigroup\/lightscript\s*(?:with ([^]*))?$/);
    if (matches) {
      result.isLightScript = true;
      if (matches[1]) getWithOptions(result, matches[1]);
    }
  }return result;
}